export class Faq {
    constructor(
        public id: number,
        public title: string,
        public description: string,
        public faqCategoryId: number,
        public displayOrder: number,
        public rank: number
    ) {}
}
